import React, { useState } from "react";
import { FormGroup, FormControl, ControlLabel } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import { useFormFields } from "../libs/hooksLib";
import { Link } from "react-router-dom";
import "./Consulta.css";
import { API } from "aws-amplify";

export default function Login(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [salvoconducto, setSalvoconducto] = useState("");
  const [note, setNote] = useState(null);
  const [condiciones_autorizacion_rechazo, setCondiciones] = useState("");
  const [id,setId] = useState("");
  const [fecha_solicitud,setFechaSolicitud] = useState("");
  const [usuario_registro,setRegistro] = useState("");
  const [estatus,setEstatus] = useState("");
  const [rtn_productor,setRTNProductor] = useState("");
  const [empresa_transporte,setEmpresa] = useState("");
  const [conductor,setConductor] = useState("");
  const [detalle_solicitud,setDetalle] = useState("");
  const [producto,setProducto] = useState("");
  const [permiso,setPermiso] = useState("");
  const [marca,setMarca] = useState("");
  const [color,setColor] = useState("");
  const [placa,setPlaca] = useState("");
  const [origen,setOrigen] = useState("");
  const [destino,setDestino] = useState("");
  const [licencia,setLicencia] = useState("");
  const [identidad_conductor,setIdentidad] = useState("");
  const [rtn_empresa,setRTNEmpresa] = useState("");
  const [fecha_inicio,setFechaInicio] = useState("");
  const [fecha_fin,setFechaFin] = useState("");

  function validateForm() {
	  return salvoconducto.length > 0;
  }

  async function handleSubmit(event) {
    event.preventDefault();

    setIsLoading(true);

    try {
      const temp_note = await API.get("notes", "/salvoconductos/" + salvoconducto);
	  if (temp_note.rows.length>0) {
      const { id,fecha_solicitud, condiciones_autorizacion_rechazo, usuario_registro, estatus, rtn_productor, empresa_transporte, conductor, detalle_solicitud, producto, permiso, marca, color, placa, origen, destino, licencia, identidad_conductor, rtn_empresa, fecha_inicio, fecha_fin } = temp_note.rows[0];
      setId("ID: " + id);
	  setEstatus("ESTATUS: " + estatus);
	  setConductor("CONDUCTOR: " + conductor);
	  setPlaca("PLACA: " + placa);
	  setLicencia("LICENCIA: " + licencia);
  } else  {
  	  setId("EL SALVOCONDUCTO NO EXISTE O NO HA SIDO AUTORIZADO");
	  setEstatus("");
	  setConductor("");
	  setPlaca("");
	  setLicencia("");
  }
    } catch (e) {
      alert(e.message);   
	}
	setIsLoading(false);
	
  }

  return (
    <div className="Login">
      <form onSubmit={handleSubmit}>
        <FormGroup controlId="salvoconducto" bsSize="large">
          <ControlLabel>Ingrese # de Salvoconducto</ControlLabel>
          <FormControl
            autoFocus
            type="salvoconducto"
            value={salvoconducto}
            onChange={e=>setSalvoconducto(e.target.value)}
          />
        </FormGroup>
        <LoaderButton
          block
          type="submit"
          bsSize="large"
          isLoading={isLoading}
          disabled={!validateForm()}
        >
          Consultar
        </LoaderButton>
	      <FormGroup bsSize="large">
	        <ControlLabel>{id} </ControlLabel>
		  </FormGroup>
		  <FormGroup bsSize="large"> 
	  	  <ControlLabel>{estatus} </ControlLabel>
		  </FormGroup>
		  <FormGroup bsSize="large"> 
	  	   <ControlLabel>{conductor} </ControlLabel> 
		  </FormGroup>
		  <FormGroup bsSize="large">
	  		 <ControlLabel>{placa} </ControlLabel> 
		  </FormGroup>
		  <FormGroup bsSize="large">
	  		 <ControlLabel>{licencia}</ControlLabel> 
	  	</FormGroup>
      </form>
    </div>
  );
}
